<template>
    <div ref="content">
        <div class="menu_top padding_bottom_64">
            <div class="cart_suggesttitle">修改密码</div>
            <div class="person_info display_flex">
                <div class="infocontain">
                    <div class="info_detail">
                       
                        <div class="margin_bottom_20">
                            <span class="info_left">手机号</span>    
                            <input type="" name="" class="infoInput" v-model="registervalue.account" placeholder="输入手机号">
                            
                        </div>
                        
                        <div class="margin_bottom_20">

                            <span class="info_left">输入验证码</span> 
                            <div class="relative">
                                <input type="" name="" class="infoInput" v-model="registervalue.verifycode" placeholder="输入验证码">
                                <div class="yanzheng" @click="getcaptcha()">{{seconds ? seconds +' S': '获取验证码' }}</div>
                            </div>
                            
                        </div>
                        <div class="margin_bottom_20">
                            <span class="info_left">新密码</span>
                            <div class="relative">
                                <input :type="inputtype" name="" class="infoInput" v-model="registervalue.password" placeholder="输入新密码">
                                <img :src="inputeye[inputtype]" class="eye" @click="isshowpassword()">
                            </div>
                        </div>
                        <div class="margin_bottom_20">
                            <span class="info_left">确认新密码</span>
                            <div class="relative">
                                <input :type="inputtype1" name="" class="infoInput" v-model="registervalue.password2" placeholder="再次输入新密码确认">
                                <img :src="inputeye[inputtype1]" class="eye" @click="isshowpassword1()">
                            </div>
                        </div>
                        <div class="savebtn" @click="save">保存新密码</div>
                        
                        
                    </div>
                </div>
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="countfun($event)"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.relative{
    position: relative;
}
input {
    background: none;
    outline: none;
    border: none;
}

input:focus {
    border: none;
}

::-webkit-input-placeholder {
    color: #999;
}

::-moz-placeholder {
    color: #999;
}

:-ms-input-placeholder {
    color: #999;
}

:-moz-placeholder {
    color: #999;
}

input,
button,
select,
textarea {
    outline: none;
    padding: 6px;
    box-sizing: border-box;
}

textarea {
    resize: none
}

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}


// 购物车
.cart_suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding: 32px 0;
    box-sizing: border-box;

    .lookall {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #262633;
        padding-right: 12px;
        box-sizing: border-box;
        position: relative;
        cursor: pointer;

        &:after {
            content: '';
            position: absolute;
            right: 0;
            top: 13px;
            width: 6px;
            height: 6px;
            border-top: 1px solid #262633;
            border-right: 1px solid #262633;
            transform: rotate(45deg);

        }
    }
}

.padding_left_394 {
    padding-left: 394px;
    box-sizing: border-box;
}

.padding_left_430 {
    padding-left: 430px;
    box-sizing: border-box;
}

.padding_left_72 {
    padding-left: 72px;
    box-sizing: border-box;
}

.padding_left_24 {
    padding-left: 24px;
    box-sizing: border-box;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.padding_left_70 {
    padding-left: 70px;
    box-sizing: border-box;
}

.padding_left_32 {
    padding-left: 32px;
    box-sizing: border-box;
}

.margin_top_32 {
    margin-top: 32px;
}

.padding_top_32 {
    padding-top: 32px;
    box-sizing: border-box;
}

.padding_left_280 {
    padding-left: 280px;
    box-sizing: border-box;
}

.padding_left_162 {
    padding-left: 162px;
    box-sizing: border-box;
}

.padding_left_366 {
    padding-left: 366px;
    box-sizing: border-box;
}

.margin_top_40 {
    margin-top: 40px;
    box-sizing: border-box;
}

.margin_bottom_32 {
    margin-bottom: 32px;
}

.padding_right_16 {
    padding-right: 16px;
    box-sizing: border-box;
}

.padding_right_28 {
    padding-right: 28px;
    box-sizing: border-box;
}

.icon_round {
    width: 24px;
    height: 24px;
    border: 1px solid #D5D5D7;
    border-radius: 50%;
}

.cartbox {
    height: 64px;
    line-height: 64px;
    background: #F8FBFD;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    text-align: left;

    .totalprice {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FF7467;
        margin-left: 30px;
    }

    .paybtn {
        width: 180px;
        height: 100%;
        line-height: 64px;
        background: #60DEB4;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        margin-left: 40px;
        vertical-align: top;
    }
}

.cartlist {

    .cartlist_Item {
        margin-top: 24px;

    }

    .person_cartlist_Item_R {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #F4F4F5;
        padding: 24px 0 24px 24px;
        box-sizing: border-box;

        .person_order_Each {
            padding-bottom: 24px;
            box-sizing: border-box;
        }

        .roundType {
            width: 72px;
            height: 72px;
            line-height: 72px;
            color: #fff;
            border-radius: 50%;
            background-color: #60DEB4;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }

        .carttitle {
            width: 385px;
            margin-right: 80px;
            margin-left: 24px;
            text-align: left;

            .title {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #262633;
                line-height: 36px;
                @include linelimt(1);
            }

            .desc {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #888888;
                line-height: 24px;
                @include linelimt(1);
                margin-top: 4px;
            }
        }

        .price {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF7467;
            padding-left: 60px;
            box-sizing: border-box;
        }

        .delbtn {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
        }
    }
}

// 个人中心
.person_info {
    width: 100%;
    height: 542px;
    position: relative;
    background: #F8FBFD;
    padding: 40px 0 0 0px;
    box-sizing: border-box;
    background-image: url('https://p1.fishqc.net/FjgAcraUjK_rmqh9tTyIs8w3r4di');
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;

    .headImage {
        width: 80px;
        height: 80px;
        line-height:80px;
        color: #fff;
        border-radius: 50%;
        border: 2px solid #fff;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        margin: 0 auto;
        cursor: pointer;
        font-size: 14px;
        box-sizing: border-box;
        position: relative;
        &:hover{
            .headimagecover{
                display: block;
            }
        }

        .uploadFile{
            position: absolute;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 999;
            cursor:pointer;
        }

    }

    .headimagecover{
        width:100%;
        height: 100%;
        position: absolute;
        left:0;
        top:0;
        background-color:rgba(0,0,0,.45);
        border-radius:50%;
        display: none;
    }

    .changeImgtip {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A8A8AD;
        line-height: 28px;
    }

    .edit_btn {
        width: 144px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 18px;
        border: 1px solid #60DEB4;
        position: absolute;
        right: 32px;
        top: 32px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #60DEB4;
        cursor: pointer;

    }

    .infocontain {
        position: absolute;
        /*left: 56px;*/
    }

    .margin_bottom_20 {
        margin-bottom: 20px;
    }

    .info_detail {
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        padding-left: 126px;
        box-sizing: border-box;
        position: relative;
        .nickname {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #51515C;
            line-height: 28px;
            padding-bottom: 10px;
            box-sizing: border-box;
        }

        .info_left {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8A8AD;
            line-height: 48px;
            padding-right: 16px;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            width: 126px;
            text-align: right;

        }

        .info_right {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #51515C;
            line-height: 28px;
        }

        .infoInput {
            width: 560px;
            height: 48px;
            background: #FFFFFF;
            border: 1px solid #F4F4F5;
            margin-left: 24px;
            box-sizing: border-box;
            padding: 6px 16px;
            box-sizing: border-box;
        }

        .infoarea {
            width: 416px;
            height: 83px;
            background: #FFFFFF;
            border: 1px solid #F4F4F5;
            line-height: 22px;
            vertical-align: top;
        }

        .inforadio {
            width: 24px;
            height: 24px;
            background-image: url('http://p1.fishqc.net/FqXqfoCJ-iPzFMFb4YDkq7XorVAW');
            background-image: url('http://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            vertical-align: middle;
            margin-right: 6px;
            // &.active{
            //     background-image: url('http://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
            // }
        }
    }
}

.person_order_box {
    height: 40px;
    line-height: 40px;
    background: #F8FBFD;
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
}

.savebtn {
    width: 144px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #60DEB4;
    border-radius: 18px;

    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-left: 46px;
    display: inline-block;
    cursor: pointer;

}
.sexname{
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    padding-left: 30px;
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    &:before{
        position: absolute;
        content: '';
        width: 24px;
        height: 24px;
        background: url('https://p1.fishqc.net/FqXqfoCJ-iPzFMFb4YDkq7XorVAW');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        left: 0;

    }
    &.active{
        &:before{
        position: absolute;
        content: '';
        width: 24px;
        height: 24px;
        background: url('https://p1.fishqc.net/FgLfRefZT_XS3oJZDITRSLQ7dsOH');
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        left: 0;

    }
}   
}

.yanzheng{
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0,-50%);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    cursor: pointer;
    &:before{
        content: '';
        position: absolute;
        left: -12px;
        width: 2px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        background-color: #D5D5D7;
        top: 50%;
        transform: translate(0,-50%);
    }
}

.eye{
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translate(0,-50%);
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    cursor: pointer;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
import Modal from '@/components/Modal.vue'
import { personinfoApi,editUserInfoapi,resetPasswordApi,login_sendCodeApi,sendResetMailapi} from '@/api/api.js'
var countTimer
var email_reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var tel_reg = /^1\d{10}$/;
export default {
    name: '',
    components: {
        banner,
        modal:Modal
    },
    mixins: [myMixin],
    data() {
        return {
            HeadImghover: false,
            personInfo:{
                image:'',
                sex:0
            },
            // register 
            registerFocus:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
            },
            registerBlur:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
            },
            registererror:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
            },
            registertip:{
                account:false,           //账号聚焦
                verifycode:false,           //验证码聚焦
                password:false,          //密码聚焦
                password2:false,   //确认密码聚焦
            },
            registervalue:{
                account:'',
                password:'',
                password2:'',
                captcha:'',     //图形验证码
                verifycode:''   //短信验证码
            },
            seconds:0,
            inputtype:'password',
            inputtype1:'password',
            inputeye:{
                'password':'https://p1.fishqc.net/FpdULKO4i791osO30dH0fQ6Xj21j',
                'text':'https://p1.fishqc.net/FtYogz2XolemdhxTdMaFg5MI539y'
            }

        }
    },
    computed: {
       
    },
    watch:{
        'personInfo':function(){    
            this.$nextTick(function(){
                //渲染完成
                var height = this.$refs.content.offsetHeight
                this.footerAuto(height)
            })
        }
    },
    mounted() {
        
        this.personinfofun()
    },
    methods: {
        tapchoose(item) {
            this.currenttap = item
        },
        changeHeadimg(type) {
            console.log(type)
            if (type == 'show') {
                
                this.HeadImghover = true
            } else {
               
                this.HeadImghover = false
            }
        },
        personinfofun(){
            personinfoApi({}).then(res => {

                if (res.code == 200) {
                    this.registervalue.account = res.data.mobile
                    console.log('个人信息',res.data.mobile)
                }else if(res.code == 401){

                }else {
                    // this.toast(res.message)
                    
                }
            })

        },
        // 
        save() {

            var that = this;

            if (!this.registervalue.account) {
                this.toast('请输入手机号')
                return
            }

            if(!tel_reg.test(this.registervalue.account)){
                this.toast('手机号格式不对！')
            }

            if (!this.registervalue.captcha) {
                this.toast('点击获取验车码！')
                this.registererror['captcha'] = true
                return
            }

            if (!this.registervalue.verifycode) {
                this.toast('请输入短信验证码！')
                this.registererror['verifycode'] = true
                return
            }

            if (!this.registervalue.password) {
                this.registererror['password'] = true
                return
            }

            if (!this.registervalue.password2) {
                this.registererror['password2'] = true
                return
            }

            if(this.registervalue.password !== this.registervalue.password2){
                this.toast('确认密码不一致！')
                return
            }
            
            resetPasswordApi({
                mobile: this.registervalue.account,
                password: this.registervalue.password,
                password2:this.registervalue.password2,
                verifycode:this.registervalue.verifycode,
                captcha: this.registervalue.captcha,
                returnURL: this.$route.query.returnURL,
                

            }).then(res => {
                if (res.code == 200) {
                    this.toast('修改密码成功！')
                    setTimeout(function(){
                        that.gorouter('/')
                    },1000)
                    // if (this.$route.query.returnURL) {
                    //     this.gorouter(this.$route.query.returnURL)
                    // } else {
                    //     this.gorouter('/')
                    // }
                } else {
                    this.toast(res.message)

                }
            })

        },
        // 弹窗显示并获取图形验车码
        getcaptcha(){
            if (!this.registervalue.account) {
                this.toast('请输入手机号')
                return
            }

            this.$refs.modaltoast.show({
                type:'verifycodemodal',
            });
        },
        // 弹窗回调传值图形验证码，倒计时开始，触发发送手机短信验证码
        countfun(data){
            var that = this;
            if(data.captcha){
                that.registervalue.captcha = data.captcha
                that.seconds = 60
                that.sendverifycode()
                countTimer = setInterval(function() {
                    that.seconds--;
                    if (that.seconds <= 0) {
                        countTimer = clearInterval(countTimer);
                    }
                }, 1000);
            }
            

        },
        // 发送手机短信
        sendverifycode(){
            login_sendCodeApi({
                mobile: this.registervalue.account,
                captcha: this.registervalue.captcha
            }).then(res => {
                if (res.code == 200) {
                   
                } else {
                    this.toast(res.message)

                }
            })
        },
        isshowpassword(){
            if(this.inputtype == 'password'){
                this.inputtype = 'text'
            }else{
                this.inputtype = 'password'
            }
        },
        isshowpassword1(){
            if(this.inputtype1 == 'password'){
                this.inputtype1 = 'text'
            }else{
                this.inputtype1 = 'password'
            }
        }

    }
}
</script>